module.exports = __webpack_public_path__ + "static/media/PCRIcon.f7711290.svg";